import { List, ListItem, ListItemText } from '@mui/material'
import { withStyles } from '@mui/styles'

export const StyledList = withStyles({
    root: {
        paddingTop: 0,
        paddingBottom: 0,
    }
})(List)

export const StyledListItem = withStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        paddingTop: 3,
        paddingBottom: 3
    },
    selected: {
      backgroundColor: theme.palette.primary.main + ' !important',
      color: 'white'
    },
}))(ListItem); 

export const StyledListItemText = withStyles({
    root: {
        color: '#5A5A5A',
        textAlign: 'center',
        fontSize: '14px'
    },
})((props) => (
    <ListItemText
    disableTypography
      {...props}
    />
));

export default StyledList;